export default [
  {
    title: 'نرخ ارز',
    icon: 'bx bx-dollar-circle',
    children: [
      {
        title: 'مدیریت نرخ ارز',
        route: { name: 'currency' },
        resource: 'CurrencyManager',
        action: 'show',
      },
    ],
  },
]
